import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';


export default class PendingAssessments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        }

        this.datasheetFieldSpecs = [
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee_employee_id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee_name', headerName: 'Assessee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 160},
            { field: 'assessment_template_id', headerName: 'Type', width: 90, align:'center',headerAlign:'center'},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'deadline_date', headerName: 'Deadline', width: 120},
            { field: 'requires_nomination', headerName: 'Nom. Req.?', align: 'center', width: 120, sortable:false},
            { field: 'nominated_assessor', headerName: 'Nominated Assessor', width: 160},
            { field: 'nominated_assessor_id', headerName: 'Nom. Assessor #', width: 110, align:'center',headerAlign:'center'},
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_pending_assessments',this.props.gwt)
        .then(reply=>{
            // console.log('query_pending_assessments reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_pending_assessments) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_pending_assessments) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    for (var i=0;i<record_array.length;i++){
                        deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                        record_array[i].deadline_date = deadline_date;
                        record_array[i].requires_nomination = record_array[i].requires_nomination? "YES" : "";
                        record_array[i].nomination_made = record_array[i].nomination_made? "YES" : "";
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : [], filtered_assessments_array:reply.Records?reply.Records : []});
                }

            }
        });
    };

    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, pending_assessments_array: []});
        this.componentDidMount();
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Pending Assessments ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Pending Assessments as at ' + dateStr + '.xlsx');
        }
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.pending_assessments_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.pending_assessments_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.pending_assessments_array){
                        if (record.assessee_name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.pending_assessments_array){
                        if (record.assessee_employee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.pending_assessments_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1380
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={4}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={4}>
                        <Typography
                            style={{padding:10}}
                        >
                            Pending Assessments
                        </Typography>
                    </Grid>

                    <Grid item xs={4}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            // style={{backgroundColor:'yellow'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.pending_assessments_array.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                // show_branch_filter={true}
                                // show_cycle_filter={true}
                            />
                        </Grid>
                    </Grid>

                </Grid>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.filtered_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={500}
                />

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1380,maxWidth:1380, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}